import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from "src/components/Placeholder";

function HundrdFreeSpinOnGaneshGoldPromoFun(props: any) {
  const {
    app: { brandId },
    theme,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isPK =
    brandId &&
    (brandId === 35 || brandId === 36 || brandId === 37 || brandId === 49);

  const minQualifyingDepositAmt =
    brandId === 61 ? "$31.60" : isPK ? "PKR 9,000" : "₹3,000";

  const maxBonusAmt = brandId === 61 ? "$10.53" : isPK ? "PKR 3,000" : "₹1,000";

  return (
    <>
      <InformationWrapper>
        {/* =========================
                    TOP CONTENT
                ========================== */}
        <TopSection>
          <h1>10 CHANCES TO DEPOSIT. 10 CHANCES TO WIN BIG.</h1>

          <p className="top-para">
            Make a qualifying deposit and get 10 Free Spins on{" "}
            <strong>Ganesha Gold</strong> — instantly. Come back and deposit
            again to claim more: up to 10
            <br className="desktop-break" />
            times during the promotion, for up to 100 Free Spins in total.
          </p>

          <p className="promotion-period">
            <strong>Promotion Period :</strong> 1 September - 31 October 2026
          </p>
        </TopSection>

        {/* =========================
                    HOW TO CLAIM
                ========================== */}
        <Section>
          <h2>How To Claim</h2>

          <ImageWrapper>
            <LazyLoadImage
              src={`${config.imageV3Host}/static/cashsite/${theme.image.HundrdFreeSpinOnGaneshGoldHowToClaimImage}`}
              alt="How To Claim"
              effect="none"
              placeholder={<PlaceholderImage />}
            />
          </ImageWrapper>
        </Section>

        {/* =========================
                    TERMS & CONDITIONS
                ========================== */}
        <Section>
          <h2>Terms & Conditions</h2>

          <TermsList>
            <li>
              Promotion Is Valid From{" "}
              <strong>1 September To 31 October 2026.</strong>
            </li>

            <li>
              The Minimum Qualifying Deposit Is{" "}
              <strong>{minQualifyingDepositAmt}</strong> In A Single Transaction.
              
            </li>

            <li>Each Qualifying Deposit Earns <strong>10 Free Spins</strong> On Ganesh Gold.</li>

            <li>
              The Maximum Bonus Per Player Is <strong>{maxBonusAmt}</strong> In
              Total.
            </li>

            <li>
              Each Player Can Claim This Promotion A Maximum Of <strong>10 Times</strong>, For Up
              To 100 Free Spins In Total.
            </li>

            <li>Free Spins Are Valid For <strong>24 Hours</strong> From The Time Of Credit.</li>

            <li>
              Only Qualifying Deposits Are Eligible. Cancelled, Reversed Or
              Invalid Deposits Will Not Qualify.
            </li>

            <li>Regular Terms & Conditions Apply.</li>
          </TermsList>
        </Section>
      </InformationWrapper>
    </>
  );
}

export default withTheme(withAppContext(HundrdFreeSpinOnGaneshGoldPromoFun));

/* =========================================================
   MAIN WRAPPER
========================================================= */

const InformationWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: auto;
  padding: 20px 0 40px;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: #eeeeee;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  color: #333333;

  h1,
  h2,
  p {
    margin: 0;
    padding: 0;
  }

  h1,
  h2 {
    color: #252235;

    text-align: center;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  h1 {
    font-size: 17px;
    text-transform: uppercase;
  }

  h2 {
    font-size: 17px;
    text-transform: capitalize;
  }

  @media (max-width: 768px) {
    padding: 12px 10px 30px;

    gap: 12px;

    h1 {
      font-size: 15px;
      line-height: 22px;
    }

    h2 {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 14px;
      line-height: 21px;
    }

    h2 {
      font-size: 15px;
    }
  }
`;

/* =========================================================
   TOP SECTION
========================================================= */

const TopSection = styled.div`
  width: 80%;
  max-width: 1040px;
  min-height: 150px;
  padding: 30px 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;

  .top-para {
    width: 100%;
    max-width: 880px;

    color: #555555;

    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;

    text-transform: none;
  }

  .top-para strong {
    color: #404040;
    font-weight: 700;
  }

  .promotion-period {
    color: #555555;

    font-size: 14px;
    font-weight: 400;
    line-height: 21px;

    text-align: center;
  }

  .promotion-period strong {
    color: #404040;
    font-weight: 700;
  }

  @media (max-width: 992px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: auto;

    padding: 25px 18px;

    gap: 14px;

    .top-para,
    .promotion-period {
      font-size: 13px;
      line-height: 20px;
    }

    .desktop-break {
      display: none;
    }
  }
`;

/* =========================================================
   COMMON WHITE SECTION
========================================================= */

const Section = styled.section`
  width: 80%;
  max-width: 1040px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;

  @media (max-width: 992px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;

    padding: 30px 15px;
  }
`;

/* =========================================================
   HOW TO CLAIM
========================================================= */

const ImageWrapper = styled.div`
  width: 78%;
  max-width: 820px;

  margin: 25px auto 0;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;

    display: block;
  }

  @media (max-width: 992px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;

    margin-top: 20px;
  }
`;

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsList = styled.ul`
  width: 52%;
  max-width: 510px;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  gap: 8px;

  margin: 25px auto 0;
  padding: 0;

  list-style: none;

  li {
    position: relative;

    color: #555555;

    background: #eeeeee;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;

    text-align: left;

    line-height: 21px;

    padding: 9px 16px 9px 36px;

    box-sizing: border-box;

    text-transform: none;
  }

  li::before {
    content: "✦";

    position: absolute;

    left: 18px;
    top: 9px;

    color: #555555;

    font-size: 11px;
  }

  li strong {
    color: #444444;
    font-weight: 700;
  }

  @media (max-width: 992px) {
    width: 65%;
  }

  @media (max-width: 768px) {
    width: 100%;

    margin-top: 20px;

    li {
      font-size: 13px;
      line-height: 20px;

      padding: 9px 12px 9px 31px;
    }

    li::before {
      left: 13px;
      top: 9px;
    }
  }

  @media (max-width: 480px) {
    li {
      font-size: 12px;
      line-height: 19px;
    }
  }
`;
